/**
 * Where PulseAssist Email's legal documents live.
 *
 * They are published on the marketing site, which is a DIFFERENT ORIGIN from this console (decision
 * 0005), so these are absolute URLs and must be plain anchors rather than wouter routes — a `<Link>`
 * would try to resolve them inside this SPA and land on its 404 screen.
 *
 * One constant rather than a string per call site: the console already carries several hardcoded
 * `https://getpulseassist.com/...` links, and a fourth and fifth copy is how one of them ends up
 * pointing at a page that has been renamed.
 *
 * The origin is overridable for the same reason the API base is: a preview deployment of the marketing
 * site is not on the production domain, and a legal link that 404s in staging gets ignored rather than
 * fixed.
 */
const SITE_ORIGIN =
  (import.meta.env.VITE_SITE_ORIGIN as string | undefined)?.trim() || "https://getpulseassist.com";

const site = (path: string): string => `${SITE_ORIGIN.replace(/\/+$/, "")}${path}`;

/**
 * The Email product's own documents.
 *
 * Deliberately the `/email/*` pair, not `/terms` and `/privacy`. Those are the AI product's documents:
 * PulseAssist Email sends mail on a customer's behalf to their own recipients, which carries
 * obligations — domain authority, unsubscribe handling, suppression, recipient permission — that the AI
 * documents do not describe. Linking a customer of THIS product at those would show them the wrong
 * agreement.
 */
export const LEGAL = {
  emailTerms: site("/email/terms"),
  emailPrivacy: site("/email/privacy"),
  /** The platform-level documents, for surfaces that need the account-wide position. */
  acceptableUse: site("/acceptable-use"),
  refundPolicy: site("/refund-policy"),
} as const;
